// theme/scripts/common/select.js

import React, { useContext } from 'react';
import * as SelectFunc from '../lib/selectFunc.js';
import { CustomizeContext } from '../contexts/customize';

const Select = ({ item, ind, name, option_type }) => {
  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

  const createMarkup = (html) => ({ __html: html });

  const selectItem = (e) => {
    const wrapper = e.currentTarget.closest('.mtm-item__wrapper');
    const stateKey = wrapper.id.replace('mtm-', '');
    const openItem = document.querySelector(`#${wrapper.id} .selects-item.open`);
    if (!openItem) return;

    const id = openItem.dataset.id;
    const label = openItem.dataset.label;
    const value = openItem.dataset.value;
    const img = openItem.dataset.img;

    // すでに同じものが選ばれている場合はスキップ
    if (
      eq(customizes[stateKey]?.id, id) &&
      eq(customizes[stateKey]?.value, value)
    ) {
      return;
    }

    // 🔄 選択状態を更新
    setCustomizes((prev) => ({
      ...prev,
      [stateKey]: {
        ...prev[stateKey],
        id,
        label,
        value,
        img,
      },
    }));

    // ✅ UI更新：active切替
    document
      .querySelectorAll(`#${wrapper.id} .selects-item`)
      .forEach((el) => {
        el.classList.remove('active', 'open');
        el.style.marginBottom = '0';
      });
    openItem.classList.add('active');

    // ✅ optionsセクションを開く
    const optionWrapper = wrapper.querySelector('.mtm-item__options');
    if (optionWrapper) {
      const hasOptions =
        option_type && Number(option_type) > 0 && optionWrapper.querySelector('[data-id]');
      optionWrapper.classList.toggle('active', Boolean(hasOptions));

      // 対応するoption-itemを開く
      if (hasOptions) {
        const parentOption = Array.from(optionWrapper.querySelectorAll('.options-item')).find(
          (opt) => eq(opt.dataset[`${stateKey}s`], value)
        );
        if (parentOption) {
          parentOption.classList.add('active');
        }
      }
    }

    // ✅ スクロール制御（次セクションへ）
    const nextWrapper = wrapper.nextElementSibling;
    if (nextWrapper) {
      nextWrapper.classList.add('active');
      const rect = nextWrapper.getBoundingClientRect();
      const py = window.pageYOffset + rect.top;
      const header_h = document.getElementById('SiteHeader')?.clientHeight || 0;
      const hasOptions = !!wrapper.querySelector('.mtm-item__selects.active');
      const offset = hasOptions ? 500 : 100;
      window.scrollTo({ top: py - header_h - offset, behavior: 'smooth' });
    }

    console.log(`✅ ${stateKey} selected →`, label);
  };

  return (
    <div
      className={`selects-item${customizes[name]?.value === item.value ? ' active' : ''}`}
      data-key={name}
      key={`${name}-${ind}`}
      data-id={item.id}
      data-label={item.label}
      data-value={item.value}
      data-img={item.image_url}
      data-optiontype={option_type}
    >
      <div className="selects-item__head" onClick={SelectFunc.openSelect}>
        <div className="selects-item__head__image">
          <img src={item.image_url} alt={item.label} />
          <div className="selects-item__head__selected">
            <svg
              width="35"
              height="26"
              viewBox="0 0 35 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M2 12.2L12.5283 23L33 2" stroke="white" strokeWidth="3" />
            </svg>
            <p>Selected</p>
          </div>
        </div>
        <h4>{item.label}</h4>
      </div>
      <div className="selects-item__detail">
        <div
          className="selects-item__detail_bg sp"
          onClick={SelectFunc.closeSelect}
        ></div>
        <div className="selects-item__detail__wrapper">
          <div
            className="selects-item__detail_closeBtn sp"
            onClick={SelectFunc.closeBtnSelect}
          ></div>
          <div
            className="selects-item__detail_contents"
            dangerouslySetInnerHTML={createMarkup(item.description)}
          />
          <div className="selects-item__detail_button">
            <button onClick={selectItem}>Select this {name}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Select;
